module.exports = __webpack_public_path__ + "img/thumbnail_ProboscisMonkey_f_normal.1f139d88.png";